import { render, staticRenderFns } from "./IngredientTextarea.vue?vue&type=template&id=0ae42d92&scoped=true&"
import script from "./IngredientTextarea.vue?vue&type=script&lang=js&"
export * from "./IngredientTextarea.vue?vue&type=script&lang=js&"
import style0 from "./IngredientTextarea.vue?vue&type=style&index=0&id=0ae42d92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae42d92",
  null
  
)

export default component.exports